import { AfterViewInit, Component, ElementRef, Inject, Input, NgZone, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { PERIMETRE_CRANIEN_PROVIDERS_TOKEN, PREIMETRE_CRANIEN_CHART_PROVIDERS_DATA, PreimetreChartProviderValue } from '../périmètre-crânien.module';
import { EUserGender } from 'src/app/entities/user.entity';
import Chart from "chart.js/auto";
@Component({
  selector: 'app-perperimetre-cranien60',
  templateUrl: './perperimetre-cranien60.component.html',
  styleUrls: ['./perperimetre-cranien60.component.css']
})
export class PerperimetreCranien60Component implements AfterViewInit, OnChanges {

  @Input() gender: EUserGender = EUserGender.HOMME;
  @Input() perimetreCranien: number = 0;
  @Input() old: number = 0;
  @Input() filter: any[] = [];

  @ViewChild("canvas") canvas!: ElementRef;
private chartInitialized = false;

  private chart!: Chart;

  get canvasContext(): any {
    return this.canvas.nativeElement.getContext("2d");
  }

  get endLabelPlugin(): any {
    return {
      id: "endLabelPlugin",
      afterDatasetsDraw(chart) {
        const {
          ctx,
          chartArea: { top, bottom, left, right },
          scales: { x, y },
        } = chart;

        chart.data.datasets.forEach((dataset, index) => {
          const meta = chart.getDatasetMeta(index);
          if (meta.hidden) return;

          const label = dataset.label;
          const dataLength = dataset.data.length;
          const lastPoint = dataset.data[dataLength - 1];
          const xPos = x.getPixelForValue(dataLength - 1);
          const yPos = y.getPixelForValue(lastPoint);

          ctx.save();
          ctx.fillStyle = dataset.borderColor;
          ctx.font = "12px Arial";
          ctx.fillText(label, xPos + 5, yPos);
          ctx.restore();
        });
      },
    };
  }

  get providerToken(): PERIMETRE_CRANIEN_PROVIDERS_TOKEN {
    if (this.gender == EUserGender.FEMME)
      return PERIMETRE_CRANIEN_PROVIDERS_TOKEN.PERIMETRE_60_M_OLD_GIRL;
    else return PERIMETRE_CRANIEN_PROVIDERS_TOKEN.PERIMETRE_60_M_OLD_MALE;

  }

  get plots(): Array<any> {
    return [
      { x: this.old, y: this.perimetreCranien },
    ];
  }
  get data(): any {
    return {
      labels: Array.from({ length: 60 }, (_, i) => i).filter((e) => (this.old > 36 ? e >= 0 : true)),
      datasets: [
        // Lignes de croissance (courbes de percentile)
        ...(this.PREIMETRE_CRANIEN_CHART_PROVIDERS_DATA.get(this.providerToken)?.map((e, i) => ({
          label: e.label,
          data: e.values,
          borderColor: ["#f7e5ee", "#f7e5ee", "#f7e5ee", "#a8faf5", "#46d5cd", "#a8faf5", "#f7e5ee", "#f7e5ee", "#f7e5ee"][i],
          backgroundColor: ["#f7e5ee", "#f7e5ee", "#f7e5ee", "#a8faf5", "#46d5cd", "#a8faf5", "#f7e5ee", "#f7e5ee", "#f7e5ee"][i],
          fill: false,
          tension: 0.4,
          pointRadius: 0,
          order: -1, // Dessin en arrière-plan
        })) || []),
        // Points des mesures de l'enfant
        {
          label: "PREIMETRE_CRANIEN ",
          data: this.plots,
          borderWidth: 3,
          borderColor: "rgba(255, 99, 132, 1)",
          backgroundColor: "rgba(255, 99, 132, 0.2)",
          pointRadius: 5,
          pointHoverRadius: 10,
          pointStyle: "circle",
          pointBackgroundColor: "red",
          pointBorderColor: "red",
          pointBorderWidth: 2,
          fill: false,
          tension: 0,
          showLine: false,
          order: 100, // Dessin en avant-plan
        }

      ]

    };
  }

  constructor(
        private ngZone: NgZone,
    
    @Inject("PREIMETRE_CRANIEN_CHART_PROVIDERS_DATA")
    private PREIMETRE_CRANIEN_CHART_PROVIDERS_DATA: Map<PERIMETRE_CRANIEN_PROVIDERS_TOKEN, Array<PreimetreChartProviderValue>>
  ) { }


ngAfterViewInit(): void {
  this.ngZone.runOutsideAngular(() => {
    this.fillChart();
    this.chartInitialized = true;
  });
}

ngOnChanges(changes: SimpleChanges): void {
  if (!this.chartInitialized) return; // ← évite l'appel prématuré
 
  this.ngZone.runOutsideAngular(() => {
    this.chart?.destroy();
    this.fillChart();
  });
}
  fillChart(): void {
      if (!this.canvas) return; // guard important

    this.chart = new Chart(this.canvasContext, {
      type: "line",
      data: this.data,
      options: {
        responsive: true,
        layout: {
          padding: {
            right: 80, // Add padding to the right to prevent label cutoff
          },
        },
        scales: {
          x: {
            min: 0,

          },
          y: {
            min: 30,
            max: 60,
            ticks: {
              stepSize: 1, // Set the step size for y-axis
            },
            grid: {
              display: true, // Show grid lines
              borderDash: [1, 1], // Dashed lines for the grid
            },
          },
        },
        plugins: {
          tooltip: {
            enabled: true, // Activer les tooltips pour les points
          },
        },
      },
      plugins: [this.endLabelPlugin],
    });
  }

  get isValid(): boolean {

    return this.isValidPerimetreCranien && this.isFitOld;
  }

  get isValidPerimetreCranien(): boolean {
    return this.perimetreCranien > 0;
  }

  get isFitOld(): boolean {
    return this.old <= 60; /* 216 is 18 years old in months*/
  }

}
